module.exports = "/packs/images/svg/facilities/personal_trainer~47ed57f1a7b3689e47e206f98e6348f8.svg";